import { PageAnalytics } from './components/PageAnalytics';
import { sendEvent, setUserProperties, whichProduct, insertIntoHead, } from './ga';
import { useTrackingConsent } from './hooks/useTrackingConsent';
import { GA_PRODUCT } from './ga/types';
export { insertIntoHead, PageAnalytics, sendEvent, setUserProperties, whichProduct, useTrackingConsent, GA_PRODUCT, };
export default PageAnalytics;
//# sourceMappingURL=index.js.map